import React, { forwardRef } from 'react'

import { capitalizeString } from '../../../../utilities/helpers'

import Card from 'react-bootstrap/Card'
import Badge from 'react-bootstrap/Badge'
import Button from 'react-bootstrap/Button'
import Stack from 'react-bootstrap/Stack'

import { EditButton } from '../../../EditButton'
import { TrashButton } from '../../../TrashButton'

import './attraction.scss'

const Attraction = forwardRef(
  (
    {
      listeners,
      attraction,
      idx,
      isDraggingDisabled,
      isDisabled,
      handleShowCreate,
      handleShowDelete,
      ...props
    },
    ref
  ) => {
    const { id, name, primary, artwork } = attraction
    // Attractions can exist before artwork does, such as drafts created by the
    // event assistant when no usable image was found.
    const { url, width, height } = artwork || {}

    const badge = primary ? 'primary' : 'secondary'

    return (
      <li ref={ref} {...props}>
        <Card body className="card-thumbnail">
          <div className="position-relative">
            {url ? (
              <Card.Img
                variant="top"
                src={url}
                width={width}
                height={height}
                alt={`Portrait of ${name}`}
              />
            ) : (
              <div className="card-thumbnail__placeholder">
                <span>No artwork</span>
              </div>
            )}
            <Badge bg={badge} className="text-uppercase">
              {capitalizeString(badge)}
            </Badge>
            {!isDisabled && (
              <Card.ImgOverlay>
                <Stack direction="horizontal" gap={3}>
                  <EditButton
                    variant="white"
                    obj={attraction}
                    onClick={handleShowCreate}
                  />
                  <TrashButton
                    variant="white"
                    id={id}
                    onClick={handleShowDelete}
                  />
                </Stack>
              </Card.ImgOverlay>
            )}
          </div>
          <Stack direction="horizontal" className="justify-content-between">
            <Card.Title as="h5" className="mb-0 text-truncate">
              {name}
            </Card.Title>
            {!isDraggingDisabled && (
              <Button
                {...listeners}
                style={{ cursor: 'move' }}
                variant="light"
                className="btn-icon btn-icon-sm btn-icon--square mt-1"
                disabled={isDisabled}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  height="20"
                  viewBox="0 0 25 25"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.5 8C10.3284 8 11 7.32843 11 6.5C11 5.67157 10.3284 5 9.5 5C8.67157 5 8 5.67157 8 6.5C8 7.32843 8.67157 8 9.5 8ZM9.5 14C10.3284 14 11 13.3284 11 12.5C11 11.6716 10.3284 11 9.5 11C8.67157 11 8 11.6716 8 12.5C8 13.3284 8.67157 14 9.5 14ZM11 18.5C11 19.3284 10.3284 20 9.5 20C8.67157 20 8 19.3284 8 18.5C8 17.6716 8.67157 17 9.5 17C10.3284 17 11 17.6716 11 18.5ZM15.5 8C16.3284 8 17 7.32843 17 6.5C17 5.67157 16.3284 5 15.5 5C14.6716 5 14 5.67157 14 6.5C14 7.32843 14.6716 8 15.5 8ZM17 12.5C17 13.3284 16.3284 14 15.5 14C14.6716 14 14 13.3284 14 12.5C14 11.6716 14.6716 11 15.5 11C16.3284 11 17 11.6716 17 12.5ZM15.5 20C16.3284 20 17 19.3284 17 18.5C17 17.6716 16.3284 17 15.5 17C14.6716 17 14 17.6716 14 18.5C14 19.3284 14.6716 20 15.5 20Z"
                    fill="#121923"
                  />
                </svg>
              </Button>
            )}
          </Stack>
        </Card>
      </li>
    )
  }
)

export { Attraction }
